import React from 'react';
import type { FC } from 'react';
import { Box, ConfirmInput } from '@wix/cli-ui-kit';
import { useWixCliAppBi } from '../../../bi-app/index.js';

interface ConfirmMinorVersionProps {
  onConfirmed: () => void;
}

export const ConfirmMinorVersion: FC<ConfirmMinorVersionProps> = (props) => {
  const { onConfirmed } = props;

  const bi = useWixCliAppBi();

  const question =
    'Changes will be visible to your app users immediately and can’t be undone. Do you want to continue?';

  return (
    <Box flexDirection="column" paddingBottom={1}>
      <ConfirmInput
        label={question}
        initialValue={true}
        onSubmit={(confirm) => {
          bi.cliFlowStepAnswered({
            question,
            questionKey: 'release_command.confirm_version_creation',
            answer: String(confirm),
          });

          if (confirm) {
            onConfirmed();
          }
        }}
      />
    </Box>
  );
};
